import React from "react";
import PropTypes from "prop-types";
import "./WorkAreaCalculationTable.scss";

export default function WorkAreaCalculationTable({ title, rows }) {
  return (
    <div className="workAreaCalculationTable">
      <div className="workAreaCalculationTable-header">
        <span className="workAreaCalculationTable-headerTier">Tier</span>
        <span className="workAreaCalculationTable-headerLabel">{title}</span>
        <span className="workAreaCalculationTable-headerAmount">Amount</span>
      </div>
      <div className="workAreaCalculationTable-body">
        {rows.map((row, index) => (
          <div
            key={`${row.description}-${index}`}
            className={`workAreaCalculationTable-row workAreaCalculationTable-row--${row.variant}`}
          >
            <span className="workAreaCalculationTable-tier">{row.tier}</span>
            <span className="workAreaCalculationTable-description">{row.description}</span>
            <span className="workAreaCalculationTable-amount">{row.amount}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

WorkAreaCalculationTable.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      tier: PropTypes.string,
      description: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      variant: PropTypes.oneOf(["detail", "bold", "muted", "highlight"]).isRequired
    })
  ).isRequired
};